export const RECIPIENT_EMAIL = 'recipientEmail';
export const RECIPIENT_NAME = 'recipientName';

export const RECIPIENTS_IDS = 'recipientsIds';
export const SELECTED_TIMEZONE = 'selectedTimezone';

export const SENDER_EMAIL = 'senderEmail';
export const SENDER_NAME = 'senderName';
export const NAME_MAX_LENGTH = 30;
export const EMAIL_MAX_LENGTH = 100;

export const YOUR_EMAIL = 'yourEmail';
export const YOUR_NAME = 'yourName';

export const USER_CONSENT = 'userConsentCheckBox';
export const EGIFT_CARD_SHARE_OPTION = 'eGiftCardShareOption';

export const ITEM_CARD_TYPE = 'itemCardType';

export const PERSONAL_MESSAGE_MAX_LENGTH = 120;
export const PERSONAL_MESSAGE_MAX_LENGTH_V2 = 250;
export const PHYSICAL_PERSONAL_MESSAGE_MAX_LENGTH_V2 = 150;
export const PERSONAL_MESSAGE = 'personalMessage';
export const PERSONAL_MESSAGE_PHYSICAL = 'personalMessagePhysical';
export const GREETINGS = 'greetings';

export const MAXIMUM_CARD_QUANTITY = 100;
export const CARD_QUANTITY = 'quantity';

export const DELIVERY_TYPE = 'deliveryType';
export const DELIVERY_TYPES = Object.freeze({
    GIFT: 'GIFT',
    SELF: 'SELF'
});

export const SHIPPING_TYPES = Object.freeze({
    RECIPIENT: 'RECIPIENT',
    SELF: 'SELF'
});
export const CARD_TYPES = Object.freeze({
    Digital: 'Digital',
    PrintAtHome: 'PrintAtHome',
    Physical: 'Physical'
});

export const CUSTOM_AMOUNT = 'customAmount';


export const WEBVIEW_KEY = 'from';
export const WEBVIEW_VALUE = 'mbapp';

export const JAPAN_LOCALE = 'ja-jp';

export const EMAIL_MAXLENGTH = 254;
export const CUSTOM_AMOUNT_MAXLENGTH = 10;


export const CONSUMER_PRODUCT_CODE = 'NORM';
export const BILLABLE_PRODUCT_FEATURE_CODE = 'ECOM';


export const PAYMENT_PLUS_RISK = 'PAYMENT_PLUS_RISK';


export const SEGMENT_IP = '0.0.0.0';
export const MULTI_REC_POPUP = 'multi_rec_popup';
export const MULTI_REC_PDP = 'PDP';
export const MULTI_REC_UNSAVED_POPUP = 'multi_rec_unsaved_popup';

export const DEFAULT_CURRENCY_CODE = 'USD';


export const EGIFT_DELIVERY_EMAIL = 'email';
export const EGIFT_DELIVERY_SHAREABLE = 'sharable';


export const SHARED_CLASS_NAME = 'clicked-share-link';
export const PROCESSING_CLASS_NAME = 'processing-status';
export const STILL_PROCESSING_CLASS_NAME = 'still-processing-status';
export const READY_CLASS_NAME = 'ready-status';
export const ACTIVE_CLASS_NAME = 'active-not-shared-yet';


export const STOREFRONT_V2 = 'STOREFRONT_V2';
export const STOREFRONT_V2_FIXED = 'STOREFRONT_V2_FIXED';
export const STOREFRONT_V2_PDP = 'STOREFRONT_V2_PDP';
export const STARBUCKSJAPAN = 'STARBUCKSJAPAN';


export const UTC_TIMEZONE = {
    city: 'UTC',
    zoneAbbr: 'UTC',
    zoneName: 'Etc/UTC'
};


export const FETCH_SHAREABLE_LINK_TIMEOUT = 6000;


export const FETCH_SHAREABLE_LINK_TIMEOUT_ERROR = 'FETCH_SHAREABLE_LINK_TIMEOUT_ERROR';


export const AUTH_REASON_CODE = Object.freeze({
    RISK_REJECTED: '101',
    AUTH_REJECTED: '103',
    RISK_REVIEW: '104',
    PREAUTH_REJECTED: '105'
});


export const PROMO_LINK = 'LINK';
export const EMAIL = 'EMAIL';



export const HAS_NOTIFICATION = 'hasNotification';
export const IS_PREVIOUS_ADDRESS = 'isPreviousAddress';


export const ADDRESS_FULLNAME = 'fullName';
export const ADDRESS_STREET1 = 'street1';
export const ADDRESS_STREET2 = 'street2';
export const ADDRESS_CITY = 'city';
export const ADDRESS_STATE = 'state';
export const ADDRESS_POSTCODE = 'postalCode';
export const ADDRESS_COUNTRY = 'countryCode';
export const LIMIT_ERROR = 'limitError';
export const SHIPPING_TOKEN = 'shippingToken';

export const MAX_PLASTIC_CARD_QUANTITY = 100;


export const AMOUNT_FIELD = 'amount';
export const CURRENCY_FIELD = 'currencyCode';
export const RECIPIENT_NAME_FIELD = 'recipientName';
export const SENDER_NAME_FIELD = 'senderName';
export const RECIPIENT_EMAIL_FIELD = 'recipientEmail';
export const SENDER_EMAIL_FIELD = 'senderEmail';
export const IS_PLASTIC_FIELD = 'isPlastic';
export const FACEPLATE_FIELD = 'faceplate';
export const IS_SELFBUY_FIELD = 'isSelfBuy';
export const PROGRAM_CODE = 'programCode';
export const MESSAGE_FIELD = 'message';
export const LOYALTY_FIELD = 'loyaltyNumber';


export const NAME_FIELD_MAX = 30;
export const FIRSTNAME_FIELD_MAX = 15;
export const LASTNAME_FIELD_MAX = 25;

export const CPF_NUMBER_FIELD = 'cpfNumber';

export const MULTI_RECIPIENTS_SELECTED = 'MULTI_RECIPIENTS_SELECTED';
export const ACCESSORIES_ADDED = 'isAccessoriesAdded';
export const CURRENT_ACCESSORY = 'currentAccessory';


export const ABANDONED_CART_STATUS_COMPLETED = 'COMPLETED';
export const ABANDONED_CART_STATUS_DRAFT = 'DRAFT';


export const INITIAL_FACEPLATES_COUNT = 10;
